import { RoomModel, RoomSearchModel } from './model';
import { Observable, zip, of } from 'rxjs';
import { catchError, map, first } from 'rxjs/operators';
import { createRoom } from './model';
import { SessionDisplay, SessionModel, SessionStayPeriod } from '../session';
import { RoomRepository } from './store';
import { MoneyPrice } from '../../core/money';
import { RoomHelperService } from './room-helper.service';

export interface PricesForStayPeriod {
  [roomId: string]: {
    [dateString: string]: MoneyPrice;
  };
}

const getRoom = (
  sessionId: SessionModel['sessionId'],
  roomId: RoomModel['roomId']
) => {
  RoomRepository.setLoading(true);
  return RoomHelperService.fetchRoom(sessionId, roomId)?.pipe(
    //TODO CHECK FIX
    first(),
    map((roomDescription) => {
      RoomRepository.setLoading(false);
      return roomDescription;
    }),
    catchError((err) => {
      RoomRepository.setLoading(false);
      console.log(err);
      return of([]);
    })
  );
};

const getRooms = (
  sessionId: SessionModel['sessionId'],
  forceFetch?: boolean
): Observable<RoomModel[]> => {
  if (RoomRepository.hasRooms() && !forceFetch) {
    RoomRepository.setLoading(false);
    return RoomRepository.rooms$;
  }
  RoomRepository.setLoading(true);
  return RoomHelperService.fetchRooms(sessionId).pipe(
    first(),
    map(([roomsDescriptions, roomsSearch]) => {
      const rooms = roomsDescriptions.map((rd) => {
        const rs =
          roomsSearch.rooms.find((r) => r.roomId === rd.roomId) ||
          ({} as RoomSearchModel);
        return createRoom(rd, rs);
      });
      RoomRepository.setRooms(rooms);
      RoomRepository.setLoading(false);
      return rooms;
    }),
    catchError((err) => {
      RoomRepository.setLoading(false);
      console.log(err);
      return of([]);
    })
  );
};

const getRoomPricesForStayPeriods = (
  stayPeriods: SessionStayPeriod[],
  currency: SessionDisplay['currency']
) => {
  const observables = stayPeriods.map((sp) =>
    RoomHelperService.getRoomsSearchForSpecificStayPeriod(sp, currency)
  );
  return zip(...observables).pipe(
    map((prices) => {
      return RoomHelperService.formatPricesForStayPeriods(stayPeriods, prices);
    })
  );
};

const getRoomsAvailability = (sessionId: SessionModel['sessionId']) => {
  return RoomHelperService.getRoomsSearch(sessionId).pipe(
    map((res) => res.unavailabilityType)
  );
};

export const RoomService = {
  getRoom,
  getRooms,
  getRoomPricesForStayPeriods,
  getRoomsAvailability,
};
